import { getBasicUserInfo } from 'src/utils/urls';

async function getUserBasicInfo({ id }: { id: string | null }) {
  if (id) {
    try {
      const response = await fetch(getBasicUserInfo(id), {
        method: 'GET',
        headers: {
          tenant: process.env.REACT_APP_TENANT_ID || '',
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok || data?.IsSuccess === false) {
        const errorMessages =
          data?.Errors?.map((err: { Message: string }) => err.Message).join(
            ', ',
          ) || 'Something went wrong. Please try again later.';

        if (response.status === 500) {
          throw new Error(
            'Something went wrong on the server. Please try again later.',
          );
        }

        throw new Error(errorMessages);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export { getUserBasicInfo };
